type DesignStatusMessageProps = {
  message: string;
  variant?: 'default' | 'error';
};

const DesignStatusMessage = ({ message, variant = 'default' }: DesignStatusMessageProps) => (
  <p className={`design-page__status${variant === 'error' ? ' design-page__status--error' : ''}`}>{message}</p>
);

export default DesignStatusMessage;
